import { BONUS_CAMPAIGN_TYPE } from '../../constants/enums';
import API_ROUTES from '../../constants/apiRoutes';
import BonusPage from './BonusPage';

const CashbackBonusPage = () => (
  <BonusPage
    type={BONUS_CAMPAIGN_TYPE.CASHBACK}
    formType='cashback'
    endpoint={API_ROUTES.CASHBACK_BONUS_CAMPAIGNS}
    apiService='wallet'
    queryType='wallet-cashback'
  />
);

export default CashbackBonusPage;
